//<!-- (c) 智汇考题 -->
import { get, post, destroy, put } from "./http";

const Api = {
  Home: {
    Announcement() {
      return get(`/api/announcement/latest`);
    },
    AnnouncementDetail(id) {
      return get(`/api/announcement/detail/${id}`);
    },
  },
  Sliders: {
    Index(params) {
        return get(`/api/sliders`, params);
    }
  },
  Topic: {
    List(params) {
      return get("/api/topics", params);
    },
    HotList() {
      return get("/api/topic/recommend_list");
    },
    Categories() {
      return get("/api/topic/categories");
    },
    Detail(id) {
      return get("/api/topic/detail/" + id);
    },
  },
  Auth: {
    PasswordLogin(params) {
      return post(`/api/login/password`, params);
    },
    PasswordForget(params) {
      return post("/api/user/change_password", params);
    },
    PhoneRegister(params) {
      return post(`/api/register/phone`, params);
    },
  },
  User: {
    Detail() {
      return get(`/api/user/detail`);
    },
    NicknameChange(params) {
      return post("/api/user/change_nickname", params);
    },
    UserPaper(params) {
      return get("/api/user/join_papers", params);
    },
    UserMockPaper(params) {
        return get("/api/user/join_mock_papers", params);
    },
    UserPractice(params) {
        return get("/api/user/join_practices", params);
    },
  },
  Other: {
    Config() {
        return get("/api/system/config");
    },
    Captcha() {
        return get(`/api/captcha/image`);
    }
  },
  Exam: {
    PaperList(params) {
      return get(`/api/exam/paper/list`, params);
    },
    PaperDetail(id) {
      return get("/api/exam/paper/detail/" + id);
    },
    PaperJoin(id, params) {
      return get("/api/exam/paper/" + id + "/join", params);
    },
    PaperJoinRecord(paperId, recordId) {
      return get("/api/exam/paper/" + paperId + "/join/" + recordId);
    },
    PracticesList(params) {
      return get("/api/exam/practice/list", params);
    },
    PracticeDetail(id) {
      return get("/api/exam/practice/detail/" + id);
    },
    PracticePlay(id, chapterId) {
      return get("/api/exam/practice/" + id + "/join/" + chapterId);
    },
    PracticeQuestionAnswerFill(id, chapterId, questionId, params) {
      return post("/api/exam/practice/" + id + "/chapter/" + chapterId + "/join/question/" + questionId + "/answer", params);
    },
    PracticeQuestion(id, questionId) {
      return get("/api/exam/practice/" + id + "/join/question/" + questionId);
    },
    PaperSubmitSingle(id, params) {
      return post("/api/exam/paper/" + id + "/submit/single", params);
    },
    PaperSubmit(id, params) {
        return post("/api/exam/paper/" + id + "/submit/all", params);
    },
    PaperRecord(id,params) {
      return get("/api/exam/paper/record/" + id, params);
    },
    Search(params) {
      return get("/api/exam/search/question", params);
    },
    MockPaper: {
      List(params) {
        return get("/api/exam/mock_paper/list", params);
      },
      Detail(id) {
        return get("/api/exam/mock_paper/detail/" + id);
      },
      Join(id) {
        return post("/api/exam/mock_paper/join/" + id);
      },
      JoinDetail(recordId) {
          return get("/api/exam/mock_paper/record/" + recordId);
      },
      SubmitSingle(recordId, params) {
        return post("/api/exam/mock_paper/" + recordId + "/submit/single", params);
      },
      SubmitAll(recordId, params) {
          return post("/api/exam/mock_paper/" + recordId + "/submit/all",params);
      },
      Record(id,params) {
        return get("/api/exam/mock_paper/record/join/" + id, params);
      },
    },
    Practice: {
      Collect(params) {
          return post(`/api/exam/paper/collect/question`, params);
      },
      CollectionStatus(params) {
          return post(`/api/exam/paper/collection/status/multi`, params);
      },
      CollectStatus(params) {
          return post(`/api/exam/paper/collection/status`, params);
      },
    },
    WrongBook: {
      Detail(params) {
          return get(`/api/exam/wrong_book`, params);
      },
      OrderMode(params) {
          return get("/api/exam/wrong_book/questions", params);
      },
      RemoveQuestion(id) {
          return destroy("/api/exam/wrong_book/delete/" + id);
      },
    },
    Collection: {
      Stats(params) {
          return get(`/api/exam/collection/stats`, params);
      },
      OrderMode(params) {
          return get("/api/exam/collection/questions", params);
      },
    }
  }
};

export default Api;
